var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    id: "svg827",
    style: {
      fill: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs831"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 23.136031,16.969434 c 0.335217,-0.36426 0.52382,-0.858104 0.524287,-1.373293 V 2.2825418 C 23.659734,1.7674459 23.471248,1.2736213 23.136031,0.90939179 22.800814,0.54516219 22.346393,0.34027659 21.872377,0.33968259 H 2.1237646 C 1.6493287,0.33984409 1.1943165,0.54448339 0.85855707,0.90870949 0.52279757,1.2729355 0.33370307,1.7670027 0.33275617,2.2825302 V 15.596141 c 9.128e-4,0.515655 0.1899913,1.009733 0.5257542,1.373993 0.33576173,0.36426 0.79078333,0.568959 1.26525423,0.569076 h 9.3545034 l 7.878115,6.128034 V 17.53921 h 2.515994 c 0.474016,-5.83e-4 0.928437,-0.205516 1.263654,-0.569776 z M 5.5814574,8.504329 c -0.3220836,0 -0.583189,0.2611054 -0.583189,0.5831891 0,0.3220836 0.2611054,0.583189 0.583189,0.583189 H 18.411616 c 0.322037,0 0.583189,-0.2611054 0.583189,-0.583189 0,-0.3220837 -0.261152,-0.5831891 -0.583189,-0.5831891 z M 4.9982684,5.5883839 c 0,-0.3220837 0.2611054,-0.5831891 0.583189,-0.5831891 H 18.411616 c 0.322037,0 0.583189,0.2611054 0.583189,0.5831891 0,0.3220836 -0.261152,0.583189 -0.583189,0.583189 H 5.5814574 c -0.3220836,0 -0.583189,-0.2611054 -0.583189,-0.583189 z m 0.583189,6.4150791 c -0.3220836,0 -0.583189,0.261152 -0.583189,0.583189 0,0.322037 0.2611054,0.583189 0.583189,0.583189 h 8.1646466 c 0.322037,0 0.583189,-0.261152 0.583189,-0.583189 0,-0.322037 -0.261152,-0.583189 -0.583189,-0.583189 z",
    id: "path825",
    style: {
      clipRule: "evenodd",
      fill: "#f28f14",
      fillRule: "evenodd",
      strokeWidth: 1.16637802
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.76cc4337ba0135e5fde4c507b9cedf5d.svg";
export { ForwardRef as ReactComponent };